(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-story-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function isRtl() {
    return window.themeVariables?.settings?.direction === 'rtl';
  }

  if (!window.__customerStoryGridBlockSelectBound) {
    window.__customerStoryGridBlockSelectBound = true;

    document.addEventListener('shopify:block:select', function (event) {
      const container = event.target.closest('[data-customer-story-grid]');
      if (!container) return;

      const scroller = container.querySelector('[data-carousel-scroller]');
      const selectedItem = event.target.closest('.customer-story-grid__mobile .customer-story-grid__item');
      if (!scroller || !selectedItem) return;

      scroller.scrollTo({
        left: selectedItem.offsetLeft * (isRtl() ? -1 : 1),
        behavior: 'smooth'
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-series-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function isRtl() {
    return window.themeVariables?.settings?.direction === 'rtl';
  }

  if (!window.__featureSeriesGridBlockSelectBound) {
    window.__featureSeriesGridBlockSelectBound = true;

    document.addEventListener('shopify:block:select', function (event) {
      const container = event.target.closest('[data-feature-series-grid]');
      if (!container) return;

      const scroller = container.querySelector('[data-carousel-scroller]');
      const selectedItem = event.target.closest('.feature-series-grid__mobile .feature-series-grid__item');
      if (!scroller || !selectedItem) return;

      scroller.scrollTo({
        left: selectedItem.offsetLeft * (isRtl() ? -1 : 1),
        behavior: 'smooth'
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-card-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function isRtl() {
    return window.themeVariables?.settings?.direction === 'rtl';
  }

  function getScrollLeft(scroller) {
    return scroller.scrollLeft * (isRtl() ? -1 : 1);
  }

  function getCenteredScrollLeft(scroller, item) {
    return item.offsetLeft - (scroller.clientWidth - item.offsetWidth) / 2;
  }

  function initServiceCardGrid(container) {
    if (container.dataset.carouselReady === 'true') return;
    container.dataset.carouselReady = 'true';

    const scroller = container.querySelector('[data-carousel-scroller]');
    if (!scroller) return;

    const items = Array.from(container.querySelectorAll('.service-card-grid__mobile .service-card-grid__item'));
    const prevButton = container.querySelector('[data-carousel-prev]');
    const nextButton = container.querySelector('[data-carousel-next]');
    const media = container.querySelector('.service-card-grid__mobile .service-card-grid__media');

    if (items.length <= 1) return;

    function syncNavHeight() {
      if (!media || !prevButton || !nextButton) return;
      const height = media.offsetHeight || 0;
      prevButton.style.height = height + 'px';
      nextButton.style.height = height + 'px';
    }

    function getClosestIndex() {
      const scrollLeft = getScrollLeft(scroller);
      let closestIndex = 0;
      let closestDistance = Infinity;

      items.forEach(function (item, index) {
        const target = getCenteredScrollLeft(scroller, item);
        const distance = Math.abs(target - scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function updateButtons() {
      const index = getClosestIndex();
      if (prevButton) prevButton.disabled = index <= 0;
      if (nextButton) nextButton.disabled = index >= items.length - 1;
    }

    function scrollToIndex(index, smooth) {
      const clamped = Math.max(0, Math.min(index, items.length - 1));
      const target = items[clamped];
      if (!target) return;

      const left = getCenteredScrollLeft(scroller, target) * (isRtl() ? -1 : 1);
      scroller.scrollTo({
        left: left,
        behavior: smooth === false ? 'auto' : 'smooth'
      });
      updateButtons();
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        scrollToIndex(getClosestIndex() - 1, true);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        scrollToIndex(getClosestIndex() + 1, true);
      });
    }

    scroller.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', function () {
      syncNavHeight();
      updateButtons();
    });

    if (window.ResizeObserver && media) {
      new ResizeObserver(syncNavHeight).observe(media);
    }

    syncNavHeight();
    updateButtons();
  }

  function initAll(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-service-card-grid]').forEach(initServiceCardGrid);
  }

  if (!window.__serviceCardGridBlockSelectBound) {
    window.__serviceCardGridBlockSelectBound = true;

    document.addEventListener('shopify:block:select', function (event) {
      const container = event.target.closest('[data-service-card-grid]');
      if (!container) return;

      const scroller = container.querySelector('[data-carousel-scroller]');
      const selectedItem = event.target.closest('.service-card-grid__item');
      if (!scroller || !selectedItem || !container.contains(selectedItem)) return;

      const left = (selectedItem.offsetLeft - (scroller.clientWidth - selectedItem.offsetWidth) / 2) * (isRtl() ? -1 : 1);
      scroller.scrollTo({ left: left, behavior: 'smooth' });

      const items = Array.from(container.querySelectorAll('.service-card-grid__mobile .service-card-grid__item'));
      const index = items.indexOf(selectedItem);
      const prevButton = container.querySelector('[data-carousel-prev]');
      const nextButton = container.querySelector('[data-carousel-next]');
      if (prevButton) prevButton.disabled = index <= 0;
      if (nextButton) nextButton.disabled = index >= items.length - 1;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spotlight-picks"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const drawer = document.getElementById("SpotlightDrawer");
  const toggleBtn = document.querySelector(".toggle-spotlight-drawer");
  const closeEls = document.querySelectorAll("[data-close-spotlight]");
	const overlay = document.querySelector(".spotlight-drawer__overlay");
  if (toggleBtn && overlay && drawer) {
    toggleBtn.addEventListener("click", () => {
			overlay.classList.add("active");
      const isOpen = drawer.getAttribute("aria-hidden") === "false";
      drawer.setAttribute("aria-hidden", isOpen ? "true" : "false");
      toggleBtn.setAttribute("aria-expanded", !isOpen);
      document.documentElement.classList.add("lock-all");
    });
  }

  closeEls.forEach(el => {
    el.addEventListener("click", () => {
			overlay.classList.remove("active")
      drawer.setAttribute("aria-hidden", "true");
      toggleBtn.setAttribute("aria-expanded", "false");
      document.documentElement.classList.remove("lock-all");

    });
  });
	const closeTeaser = document.querySelector(".close-teaser");
  const fixedBtn = document.querySelector(".spotlight-fixed-btn");

  if (closeTeaser && fixedBtn) {
    closeTeaser.addEventListener("click", function(e) {
      e.preventDefault();
			e.stopPropagation();
      fixedBtn.style.display = "none";
    });
  }
	  document.querySelectorAll(".spotlight__item-actions[is='copy-to-clipboard'] button")
    .forEach(function(btn) {
      btn.addEventListener("click", function(e) {
        e.preventDefault();

        const parent = btn.closest(".spotlight__item-actions");
        const copyValue = parent.getAttribute("data-copy-value");
        const tooltip = parent.querySelector(".tooltip");

        if (copyValue) {
          navigator.clipboard.writeText(copyValue).then(() => {
            tooltip.style.opacity = "1";
            tooltip.style.visibility = "visible";
            setTimeout(() => {
              tooltip.style.opacity = "0";
              tooltip.style.visibility = "hidden";
            }, 1500);
          }).catch(err => {
            console.error("复制失败: ", err);
          });
        }
      });
    });
});

  } catch(e) { console.error(e); }
})();
})();
